import React from 'react'

export default function ExternalLink(props){
    const {
        to,
        href,
        children,
        className,
        style,
    } = props

    return(
        <a
            href={href || to}
            target='_blank'
            rel='noreferrer noopener'
            className={className}
            style={style}
        >
            {children}
        </a>
    )
}
